const getters = {
  getSelectSource: (state) => state.selectedSource
}

export default getters
